export default __webpack_public_path__ + "static/media/004-B-mesureProtection.ae7b23ef.svg";